import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SharedService } from 'app/shared/services/shared.service';
import { BehaviorSubject, EMPTY, Observable } from 'rxjs';
import { environment as env } from '@env/environment';
import { QuestionAndAnswer } from '../../modal/clients';

@Injectable({
  providedIn: 'root'
})
export class RequiredServicesService {
  requiredService$: BehaviorSubject<any> = new BehaviorSubject(null);
  dataRequiredService$ = this.requiredService$.asObservable();

  reloadData: BehaviorSubject<any> = new BehaviorSubject(null);
  reloadData$ = this.requiredService$.asObservable();
  constructor(
    private http: HttpClient,
    private _SharedService: SharedService
  ) { }

  onReloadDialog() {
    let isReload: boolean = false;
    isReload != isReload
    this.reloadData.next(isReload);
  }

  // ----------------------------- Get ---------------------------
  getDateRequiredService(data: any) {
    this.requiredService$.next(data)
  }
  GetAllRequiredServices(companyCycleId: number): Observable<any> {
    return this.http.get<any>(`${env.domain}ClientRequiredService/GetAllRequiredServicesGroupedByStep?companyCycleId=${companyCycleId}`);
  }
  GetAllClientWorkSites(clientId: number): Observable<any> {
    return this.http.get<any>(`${env.domain}ClientWorkSites/GetAllClientWorkSites/${clientId}`);
  }
  GetAllCommunicationsByClient(clientId: number): Observable<any> {
    return this.http.get<any>(`${env.domain}ClientRequiredService/GetAllCommunicationsByClient/${clientId}`);
  }
  GetAllCommunicationsByServiceID(serviceID: number): Observable<any> {
    return this.http.get<any>(`${env.domain}ClientRequiredService/GetRequiredServiceCommunicationTimelines?serviceId=${serviceID}`);
  }
  GetRequiredServiceProgressTimelines(id: any): Observable<any> {
    return this.http.get<any>(`${env.domain}ClientRequiredService/GetRequiredServiceProgressTimelines?serviceId=${id}`);
  }
  getCycleByCompanyId(companyId:number):Observable<any>{
    return this.http.get(`${env.domain}ShareCompanyCycle/GetAllSharCompanyCycle/${companyId}`)
  }
  GetRequiredServiceById(requiredServiceById: any): Observable<any> {
    return this.http.get<any>(`${env.domain}ClientRequiredService/GetRequiredServiceById/${requiredServiceById}`);
  }
  GetRequiredServiceQuestionsAndAnswer(requiredServiceById: number): Observable<QuestionAndAnswer[]> {
    return this.http.get<QuestionAndAnswer[]>(`${env.domain}ClientRequiredService/GetRequiredServiceQuestionsAndAnswers?serviceId=${requiredServiceById}`);
  }
  GetAllRequiredServicesByClientId(clientId: any): Observable<any> {
    return this.http.get<any>(`${env.domain}ClientRequiredService/GetAllRequiredServicesByClientId?clientId=${clientId}`);
  }

  // GetAllRequiredServices(query?: any): Observable<any> {
  //   const value: any = {};
  //   for (const key in query) {
  //     if (query[key]) {
  //       value[key] = query[key];
  //     }
  //   }
  //   return this.http.get<any>(`${env.domain}ClientRequiredService/GetAllRequiredServices`, { params: value });
  // }
  RequiredServiceSectorsAndSectorsFields(query: any = {}){
    const value: any = {};
    for (const key in query) {
      if (query[key]) {
        value[key] = query[key];
      }
    }
    return this.http.get<any>(`${env.domain}ClientRequiredService/RequiredServiceSectorsAndSectorsFields`, { params: value });
  }
  GetAllSuperServices(): Observable<any> {
    return this.http.get<any>(`${env.domain}SuperService/GetAllSuperServices`);
  }
  AllDepartments(superServiceId: number): Observable<any> {
    return this.http.get<any>(`${env.domain}Department/AllDepartments?superServiceId=${superServiceId}`);
  }
  AllServices(departmentId: number): Observable<any> {
    return this.http.get<any>(`${env.domain}Services/AllServices?departmentId=${departmentId}`);
  }
  AllSubServices(serviceId: number): Observable<any> {
    return this.http.get<any>(`${env.domain}SubService/AllSubServices?serviceId=${serviceId}`);
  }
  AllCategories(subServiceId: number): Observable<any> {
    return this.http.get<any>(`${env.domain}Category/AllCategories?subServiceId=${subServiceId}`);
  }
  AllSubCategories(categoryId: number): Observable<any> {
    return this.http.get<any>(`${env.domain}Subcategory/AllSubCategories?categoryId=${categoryId}`);
  }
  getListOfCurrentAssignedRole(): Observable<any> {
    return this.http.get<any>(`${env.domain}ClientRequiredService/ListOfCurrentAssignedRole`);
  }


  // ----------------------------- add ---------------------------
  AddClientWorkSite(body: any): Observable<any> {
    return this.http.post<any>(`${env.domain}ClientWorkSites/AddClientWorkSite`, body);
  }
  AssignServiceToNextStep(requiredServiceId: number) {
    return this.http.post<any>(`${env.domain}ClientRequiredService/AssignToNextStep?serviceId=${requiredServiceId}`, requiredServiceId);
  }
  // }
  // AssignServiceToSpecificRole(value: { serviceId: number, roleId: number }) {
  //   return this.http.post<any>(`${env.domain}ClientRequiredService/AssignServiceToSpecificRole?serviceId=${value.serviceId}&roleId=${value.roleId}`, {});
  // }
  ReassignServiceToPreviousUser(value: { serviceId: number, previousAssignedRoleId: number }) {
    return this.http.post<any>(`${env.domain}ClientRequiredService/ReassignServiceToPreviousUser?serviceId=${value.serviceId}&previousAssignedRoleId=${value.previousAssignedRoleId}`, {});
  }
  AssignServiceToUser(serviceId: number) {
    return this.http.post<any>(`${env.domain}ClientRequiredService/AssignServiceToUser?serviceId=${serviceId}`, {});
  }
  AddCommunicationTimeline(body: any) {
    return this.http.post<any>(`${env.domain}ClientRequiredService/AddCommunicationTimeline`, body);
  }
  ReassignServiceToPreviousUserForFeedback(value: { serviceId: number , reason:string}){
    return this.http.post<any>(`${env.domain}ClientRequiredService/ReassignServiceToPreviousUserForFeedback?serviceId=${value.serviceId}&reason=${value.reason}`, {});
  }
  AddProgressTimeline(body: any): Observable<any> {
    return this.http.post<any>(`${env.domain}ClientRequiredService/AddProgressTimeline`, body);
  }
  AddClientRequiredService(body: any): Observable<any> {
    return this.http.post<any>(`${env.domain}ClientRequiredService/AddClientRequiredService`, body);
  }


  // ----------------------------- update ---------------------------
  UpdateClientWorkSite(body: any): Observable<any> {
    return this.http.put<any>(`${env.domain}ClientWorkSites/UpdateClientWorkSite/${body.id}`, body);
  }
  UpdateClientRequiredService(body: any): Observable<any> {
    return this.http.put<any>(`${env.domain}ClientRequiredService/UpdateClientRequiredService/${body.id}`, body);
  }



  // ----------------------------- delete ---------------------------
  DeleteClientRequiredService(requiredServiceId: number): Observable<any> {
    return this.http.delete<any>(`${env.domain}ClientRequiredService/DeleteClientRequiredService/${requiredServiceId}`,)
  }
  DeleteClientWorkSite(id: number): Observable<any> {
    return this.http.delete<any>(`${env.domain}ClientWorkSites/DeleteClientWorkSite/${id}`,)
  }

}
